const container = document.querySelector('.custom-scroll-container');
const inner = container.querySelector('.custom-scroll-inner');

let currentX = 0;

function updateCurrentXFromTransform() {
  const match = inner.style.transform.match(/translate3d\((-?\d+(?:\.\d+)?)px,/);
  if (match) {
    currentX = parseFloat(match[1]);
  }
}

container.addEventListener('wheel', (e) => {
  e.preventDefault();

  const deltaX = e.deltaX || e.deltaY;
  currentX -= deltaX;

  const maxTranslate = inner.scrollWidth - container.offsetWidth;
  currentX = Math.max(Math.min(currentX, 0), -maxTranslate);

  inner.style.transform = `translate3d(${currentX}px, 0, 0)`;
}, { passive: false });


function updateArrowColorBasedOnImage() {
  const img = document.querySelector('.mySwiper2 .swiper-slide-active img');
  if (!img) return;
  if (!img.complete) {
    img.addEventListener('load', updateArrowColorBasedOnImage);
    return;
  }
  const isLifestyle = img.src.includes('lifestyle');
  document.querySelectorAll('.main-prev, .main-next, .thumbnail-prev, .thumbnail-next')
    .forEach(el => {
      el.classList.toggle('arrows-light', isLifestyle);
      el.classList.toggle('arrows-dark', !isLifestyle);
    });
}

function updateThumbnailImageFit() {
  const thumbs = document.querySelectorAll('.mySwiper .swiper-slide img');

  thumbs.forEach(img => {
    if (!img.complete) {
      img.addEventListener('load', updateThumbnailImageFit, { once: true });
      return;
    }

    const isWide = img.naturalWidth > img.naturalHeight;
    img.style.objectFit = isWide ? 'contain' : 'cover';
  });
}

function updateArrowsDisplay(swiper) {
  const index = swiper.activeIndex;
  const lastIndex = swiper.slides.length - 1;

  const mainPrev = document.querySelector('.main-prev');
  const mainNext = document.querySelector('.main-next');
  const thumbPrev = document.querySelector('.thumbnail-prev');
  const thumbNext = document.querySelector('.thumbnail-next');

  const atFirst = index === 0;
  const atLast = index === lastIndex;

  const displayPrev = atFirst ? 'none' : 'flex';
  const displayNext = atLast ? 'none' : 'flex';

  mainPrev?.setAttribute('style', `display: ${displayPrev} !important`);
  mainNext?.setAttribute('style', `display: ${displayNext} !important`);
  thumbPrev?.setAttribute('style', `display: ${displayPrev} !important`);
  thumbNext?.setAttribute('style', `display: ${displayNext} !important`);
}

function initSwipers() {
  const isMobile = window.innerWidth <= 768;

  window.thumbSwiper?.destroy(true, true);
  window.mainSwiper?.destroy(true, true);

  const thumbSwiper = new Swiper('.mySwiper', {
    loop: isMobile,
    spaceBetween: 10,
    slidesPerView: 5,
    centeredSlides: false,
    draggable: true,
    slideToClickedSlide: true,
    freeMode: true,
    watchSlidesProgress: true,
    on: {
      init() {
        document.querySelector('.thumbnail-swiper-wrapper')?.classList.add('swiper-loaded');
        updateThumbnailImageFit();
      },
      slideChange() {
        updateArrowColorBasedOnImage();
        updateThumbnailImageFit();
        updateCurrentXFromTransform();
      }
    }
  });

  const mainSwiper = new Swiper('.mySwiper2', {
    loop: false,
    spaceBetween: 10,
    slideToClickedSlide: true,
    thumbs: { swiper: thumbSwiper },
    on: {
      init() {
        updateArrowColorBasedOnImage();
        if (!isMobile) updateArrowsDisplay(this);
      },
      slideChange() {
        setTimeout(updateArrowColorBasedOnImage, 0);
        if (!isMobile) {
          const index = mainSwiper.activeIndex;
          thumbSwiper.slideTo(index, 300);
          updateArrowsDisplay(this);
        }
      }
    }
  });

  if (!isMobile) {
    document.querySelector('.main-prev')
      ?.addEventListener('click', () => mainSwiper.slidePrev());
    document.querySelector('.main-next')
      ?.addEventListener('click', () => mainSwiper.slideNext());
    document.querySelector('.thumbnail-prev')
      ?.addEventListener('click', () => mainSwiper.slidePrev());
    document.querySelector('.thumbnail-next')
      ?.addEventListener('click', () => mainSwiper.slideNext());
  }

  if (!isMobile) {
    const mainSwiperEl = document.querySelector('.mySwiper2');

    mainSwiperEl?.addEventListener('click', (e) => {
      if (e.target.closest('.main-prev') || e.target.closest('.main-next')) {
        return;
      }

      const rect = mainSwiperEl.getBoundingClientRect();
      ((e.clientX - rect.left) < rect.width / 2)
        ? mainSwiper.slidePrev()
        : mainSwiper.slideNext();
    });
  }

  window.thumbSwiper = thumbSwiper;
  window.mainSwiper = mainSwiper;
}

document.addEventListener('DOMContentLoaded', initSwipers);

new MutationObserver(() => {
  if (document.querySelector('.mySwiper2') && !document.querySelector('.swiper-loaded')) {
    initSwipers();
  }
}).observe(document.body, { childList: true, subtree: true });

document.querySelectorAll('product-types article a')
  .forEach(a =>
    a.addEventListener('click', () => setTimeout(initSwipers, 1000))
  );